const DRAWER_WIDTH_XS = '100vw';

const responsiveDrawerLayoutMixin = {
  computed: {
    mx_currentDrawerWidth() {
      if (this.xs) return DRAWER_WIDTH_XS;
      if (this.xl) return this.drawerWidth_xl + 16;
      return this.drawerWidth;
    },
    mx_currentDrawerWidthStr() {
      if (this.xs) return DRAWER_WIDTH_XS;
      return `${this.mx_currentDrawerWidth}px`;
    },
  },
};
export default responsiveDrawerLayoutMixin;
